/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import { useSuppliers, useTemplate, useUsers } from '../../hooks';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Box, Typography } from '@material-ui/core';
import useCompany from '../../hooks/useCompany';
import { useLazyQuery, useMutation } from '@apollo/client';
import { getFormOperations } from '../../graphql/query';
import {
  createFormOperation,
  deleteFormOperation,
  updateFormOperation,
} from '../../graphql/mutation';
import { getColumns } from '../constants/columns';
import { userroles } from '../constants';
import { errorAlert, errorDeleteAlert, getRowId } from '../common/funcs';
import PageLayout from '../shared/PageLayout';
import DateNavigatorReports from '../shared/DateNavigatorReports';
import { TableComponent } from '../components/TableComponent';
import {
  createdAtFormatter,
  currencyFormatter,
  operationNameFormatter,
  userFormatter,
} from '../common/formater';
import { Command } from '../components/Command';
import SearchTable from '../components/SearchTable';
import PopupEditing from '../components/PopupEditing';
import AlertLocal from '../components/AlertLocal';

import PopupSupplierForm from './PopupSupplierForm';
import PopupSupplierFormView from './PopupSupplierFormView';

// Supplier Contract opType = 100
const SUPPLIER_CONTRACT_OPTYPE = 100;

export default function SupplierForms({ isRTL, words, theme, menuitem }: any) {
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [rows, setRows] = useState([]);
  const [start, setStart] = useState<any>(null);
  const [end, setEnd] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const [item, setItem] = useState(null);
  const [openItem, setOpenItem] = useState(false);

  const [currentViewName, setCurrentViewName] = useState('Day');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();
  const { suppliers } = useSuppliers();
  const col = getColumns({ isRTL, words });
  const { tempoptions } = useTemplate();
  const { users } = useUsers();

  const columns = [
    col.createdAt,
    col.docNo,
    {
      name: isRTL ? 'supplierNameAr' : 'supplierName',
      title: isRTL ? 'المورد' : 'Supplier',
    },
    { name: 'supplierPhone', title: isRTL ? 'هاتف المورد' : 'Supplier Phone' },
    col.startDate,
    { name: 'endDate', title: isRTL ? 'تاريخ النهاية' : 'End Date' },
    col.amount,
    col.desc,
    col.userId,
  ];

  const [tableColumnExtensions]: any = useState([
    { columnName: 'createdAt', width: 150 },
    { columnName: 'docNo', width: 120 },
    { columnName: isRTL ? 'supplierNameAr' : 'supplierName', width: 180 },
    { columnName: 'supplierPhone', width: 150 },
    { columnName: col.startDate.name, width: 130 },
    { columnName: 'endDate', width: 130 },
    { columnName: 'amount', width: 120 },
    { columnName: 'desc', width: 200 },
    { columnName: 'userId', width: 120 },
  ]);

  const [loadOperations, operationsData]: any = useLazyQuery(
    getFormOperations,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  const refresQuery = {
    refetchQueries: [
      {
        query: getFormOperations,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
          opType: SUPPLIER_CONTRACT_OPTYPE,
        },
      },
    ],
  };

  const [addFormOperation] = useMutation(createFormOperation, refresQuery);
  const [editFormOperation] = useMutation(updateFormOperation, refresQuery);
  const [removeFormOperation] = useMutation(deleteFormOperation, refresQuery);

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
      opType: SUPPLIER_CONTRACT_OPTYPE,
    };
    if (start && end) {
      loadOperations({
        variables,
      });
    }
  }, [start, end]);

  useEffect(() => {
    if (operationsData?.loading) {
      setLoading(true);
    }
    if (operationsData?.data?.getFormOperations?.data) {
      setRows(operationsData?.data?.getFormOperations?.data);
      setLoading(false);
    }
  }, [operationsData]);

  const currentViewNameChange = (e: any) => {
    setCurrentViewName(e.target.value);
  };

  const currentDateChange = (curDate: any) => {
    setCurrentDate(curDate);
  };

  const endDateChange = (curDate: any) => {
    setEndDate(curDate);
  };

  const onCloseItem = () => {
    setOpenItem(false);
    setItem(null);
  };

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const _id = deleted[0];
      const res = await removeFormOperation({ variables: { _id } });
      if (res?.data?.deleteFormOperation?.ok === false) {
        if (res?.data?.deleteFormOperation?.error.includes('related')) {
          await errorDeleteAlert(setAlrt, isRTL);
        } else {
          await errorAlert(setAlrt, isRTL);
        }
      }
    }
  };

  const refresh = () => {
    operationsData?.refetch();
  };

  const bgcolor = '#EFFAF100';

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      bgcolor={bgcolor}
      loading={loading}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
          backgroundColor: bgcolor,
        }}
      >
        <Box
          display="flex"
          style={{
            position: 'absolute',
            zIndex: 111,
            flexDirection: 'row',
            alignItems: 'center',
            paddingTop: 10,
            paddingBottom: 5,
            paddingLeft: 60,
            paddingRight: 60,
            width: '100%',
          }}
        >
          <DateNavigatorReports
            setStart={setStart}
            setEnd={setEnd}
            currentDate={currentDate}
            currentDateChange={currentDateChange}
            currentViewName={currentViewName}
            currentViewNameChange={currentViewNameChange}
            endDate={endDate}
            endDateChange={endDateChange}
            views={[1, 7, 30, 365, 1000]}
            isRTL={isRTL}
            words={words}
            theme={theme}
          ></DateNavigatorReports>
        </Box>
        <Paper
          elevation={5}
          style={{
            marginTop: 10,
            marginLeft: 40,
            marginRight: 40,
            marginBottom: 20,
            overflow: 'auto',
            width: width - 320,
            borderRadius: 10,
          }}
        >
          <Grid rows={rows} columns={columns} getRowId={getRowId}>
            <SortingState />
            <EditingState onCommitChanges={commitChanges} />
            <SearchState />
            <PagingState defaultCurrentPage={0} defaultPageSize={10} />

            <IntegratedSorting />
            <IntegratedFiltering />
            <IntegratedPaging />
            <DragDropProvider />
            <Table
              messages={{
                noData: isRTL ? 'لا يوجد بيانات' : 'no data',
              }}
              tableComponent={TableComponent}
              rowComponent={(props: any) => (
                <Table.Row {...props} style={{ height: 68 }}></Table.Row>
              )}
              columnExtensions={tableColumnExtensions}
            />
            <TableColumnReordering
              defaultOrder={[
                'createdAt',
                'docNo',
                isRTL ? 'supplierNameAr' : 'supplierName',
                'supplierPhone',
                col.startDate.name,
                'endDate',
                'amount',
                'desc',
                'userId',
              ]}
            />
            <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />
            <TableHeaderRow
              showSortingControls
              titleComponent={({ children }) => {
                return (
                  <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                    {children}
                  </Typography>
                );
              }}
            />
            <TableColumnVisibility
              columnExtensions={[]}
              defaultHiddenColumnNames={[]}
            />
            <DataTypeProvider
              for={['startDate', 'createdAt', 'endDate']}
              formatterComponent={createdAtFormatter}
            ></DataTypeProvider>
            <DataTypeProvider
              for={['userId']}
              formatterComponent={(props: any) =>
                userFormatter({ ...props, users })
              }
            ></DataTypeProvider>
            <DataTypeProvider
              for={['amount']}
              formatterComponent={currencyFormatter}
            ></DataTypeProvider>
            {userroles?.formdocs?.view && (
              <DataTypeProvider
                for={['docNo']}
                formatterComponent={(props: any) =>
                  operationNameFormatter({
                    ...props,
                    setItem,
                    setOpenItem,
                    isRTL,
                  })
                }
              ></DataTypeProvider>
            )}
            <TableEditColumn
              showEditCommand={userroles?.formdocs?.edit}
              showDeleteCommand={userroles?.formdocs?.delete}
              showAddCommand={userroles?.formdocs?.add}
              commandComponent={Command}
            ></TableEditColumn>
            <Toolbar />
            <ColumnChooser />
            <PagingPanel
              pageSizes={
                tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]
              }
            />
            <SearchPanel
              inputComponent={(props: any) => {
                return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
              }}
            />

            <PopupEditing
              theme={theme}
              addAction={addFormOperation}
              editAction={editFormOperation}
              company={company}
            >
              <PopupSupplierForm
                words={words}
                suppliers={suppliers}
                opType={SUPPLIER_CONTRACT_OPTYPE}
                theme={theme}
              ></PopupSupplierForm>
            </PopupEditing>
          </Grid>
        </Paper>
        {alrt.show && (
          <AlertLocal
            isRTL={isRTL}
            type={alrt?.type}
            msg={alrt?.msg}
            top
          ></AlertLocal>
        )}
        <PopupSupplierFormView
          open={openItem}
          onClose={onCloseItem}
          row={item}
          theme={theme}
          company={company}
          suppliers={suppliers}
        ></PopupSupplierFormView>
      </Box>
    </PageLayout>
  );
}
